
import Vue from 'vue';
import { ClientConstants } from '../client.constants';
import { PvdModal } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let app: any;

export default Vue.extend({
    name: 'SideBar',
    props: {},
    data: () => {
        return {
            clientConstants: ClientConstants,
            assumptionsContent: ClientConstants.ASSUMPTIONS_MODAL_CONTENT,
            termsContent: ClientConstants.TERMS_MODAL_CONTENT,
            nextStepsSidebar: {
                nextStepsTitle: ClientConstants.NEXT_STEPS_SIDEBAR.nextStepsTitle,
                nextStepsLinks: [
                    {
                        title: ClientConstants.NEXT_STEPS_SIDEBAR.nextStepsLinks[0].title,
                        link: app ? `${app.searchBondsUrl}` : ''
                    },
                    {
                        title: ClientConstants.NEXT_STEPS_SIDEBAR.nextStepsLinks[1].title,
                        link: app ? `${app.taxImplicationsUrl}` : '',
                    }, 
                    {
                        title: ClientConstants.NEXT_STEPS_SIDEBAR.nextStepsLinks[2].title,
                        link: app ? `${app.searchAnnuitiesUrl}` : '',
                    }
                ]
            },
        };
    },
    methods: {
        openAssumptions() {
            let assumptionsModal = this.$refs['assumptions-modal'] as PvdModal;
            assumptionsModal.pvdOpen = true;
        },
        openTerms() {
            let termsModal = this.$refs['terms-modal'] as PvdModal;
            termsModal.pvdOpen = true;
            
        },
    },
});
